import Swiper, { Navigation } from 'swiper';

Swiper.use([Navigation]);

const swiper = new Swiper('.useful-link-swiper', {
    slidesPerView: 2,
    spaceBetween: 60,
    navigation: {
        nextEl: ".swiper-next",
        prevEl: ".swiper-prev",
    },
    breakpoints: {
        320: {
          slidesPerView: 2,
          spaceBetween: 60,
        },
        768: {
          slidesPerView: 4,
          spaceBetween: 40,
        },
        1024: {
          slidesPerView: 6,
          spaceBetween: 50,
        },
        1440: {
          slidesPerView: 8,
          spaceBetween: 50
        }
    },
});